import { render, staticRenderFns } from "./issueFilter.vue?vue&type=template&id=5b393838&scoped=true&"
import script from "./issueFilter.vue?vue&type=script&lang=ts&"
export * from "./issueFilter.vue?vue&type=script&lang=ts&"
import style0 from "./issueFilter.vue?vue&type=style&index=0&id=5b393838&lang=scss&scoped=true&"
import style1 from "./issueFilter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b393838",
  null
  
)

export default component.exports